export const hcExtra = {
  reservas: {
    buscar: "Buscar",
    limpiar: "Limpiar",
    todas: "Todos",
  },
  nav: {
    volver: "Volver",
  },
  listingDetail: {
    badgeNew: "Nuevo",
  },
  ofertas: {
    precio: "Precio",
  },
  payService: {
    sendRequest: "Enviar Solicitud",
  },
  accountCfg: {
    accountEmail: "Correo de la cuenta",
  },
};
